import { root } from './search';

export const search = {
  ...root,
};
